<template>
	<div>
		<el-button type="primary" @click="expor" style="float: right;">导出</el-button>
		<el-table :data="list" :header-cell-style="{ background: '#F2F2F4', 'text-align': 'center' }"
			:cell-style="{'text-align': 'center'}" style="width: 100%">
			<!-- <el-table-column prop="userId" label="提交人"></el-table-column> -->
			<!-- <el-table-column prop="name" label="企业名称"></el-table-column> -->
			<el-table-column prop="address" label="地址"></el-table-column>
			<el-table-column prop="name" label="联系人"></el-table-column>
			<el-table-column prop="telephone" label="联系电话"></el-table-column>
			<el-table-column prop="time" label="预约时间"></el-table-column>
			<el-table-column prop="other" label="其他需求"></el-table-column>
			<el-table-column label="备注">
				<template slot-scope="scope">
					<el-button v-if="scope.row.edit==false && scope.row.msg=='' " type="text"
						@click="edit(scope.row)">填写备注</el-button>
					<div v-else style="display: flex;float: left;margin-right: 20px;">
						<el-input type="textarea" autosize maxlength="100" v-model="scope.row.msg" clearable></el-input>
						<el-button type="text" @click="changeMsg(scope.row.id,scope.row.msg)">保存</el-button>
					</div>
				</template>
			</el-table-column>
			<el-table-column label="操作">
				<template slot-scope="scope">
					<el-button type="text" @click="changeStatus(scope.row.id,scope.row.status)">
						{{scope.row.status==0?'未回访':'已回访'}}</el-button>
					<el-button type="text" @click="del(scope.row.id)" style="color: #ff0000;">删除</el-button>
				</template>
			</el-table-column>
		</el-table>
		<div class="pagechange">
			<el-pagination class="pages" @size-change="handleSizeChange01" @current-change="handleCurrentChange01"
				:current-page="filter.pageNum" :page-sizes="[10,20,50]" :page-size="filter.pageSize"
				layout="total, sizes, prev, pager, next, jumper" :total="filter.total">
			</el-pagination>
		</div>
	</div>
</template>


<script>
	import {
		export2Excel
	} from '../../common/js/util'
	export default {
		data() {
			return {
				list: [],
				filter: {
					pageNum: 1, //页码
					pageSize: 10, // 条数
					total: 0
				},
				columns: [{
					title: '企业名称',
					key: 'name'
				}, {
					title: '地址',
					key: 'address'
				}, {
					title: '联系人',
					key: 'contact'
				}, {
					title: '联系电话',
					key: 'telephone'
				}, {
					title: '预约时间',
					key: 'time'
				}, {
					title: '其他需求',
					key: 'other'
				}]
			}
		},
		mounted() {
			this.getList()
		},
		methods: {
			expor() {
				export2Excel(this.columns, this.list)
				this.getList()
			},
			edit(row) {
				row.edit = true
			},
			getList() {
				var a = "?pageNum=" + this.filter.pageNum + "&pageSize=" + this.filter.pageSize
				this.$http.get("DNotice/listCut" + a).then(res => {
					this.list = res.body.data.records
					this.filter.total = res.body.total
					this.list.forEach(d => {
						this.$set(d, "edit", false)
					})
				})
			},
			changeStatus(id, status) {
				if (status == 0) {
					this.$http.get("DNotice/change" + "?id=" + id).then(res => {
						if (res.body.code == 200) {
							this.$message.success("回访成功");
							this.getList();
						}
					})
				} else {
					this.$message.success("已回访");
				}
			},
			changeMsg(id, msg) {
				if (msg == null) {
					msg = ''
				}
				this.$http.get("DNotice/changeMsg" + "?id=" + id + "&msg=" + msg).then(res => {
					if (res.body.code == 200) {
						this.$message.success("保存成功");
						this.getList();
					} else {
						this.$message.success("保存失败");
					}
				})
			},
			del(id) {
				this.$http.post("DNotice/delDNotice" + "?id=" + id).then(res => {
					if (res.body.code == 200) {
						this.$message.success("删除成功");
						this.getList();
					}
				})
			},
			handleSizeChange01(val) {
				this.filter.pageSize = val;
				this.getList()
			},
			handleCurrentChange01(val) {
				this.filter.pageNum = val;
				this.getList()
			}
		}
	}
</script>

<style>
	.pagechange {
		margin-top: 20px;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		align-items: center;
	}
</style>